import Call from '../Call.v2';

const PcCutoff = {
    getDefault() {
        return Call('pcCutoff/default');
    },

    saveDefault(type, cutoff) {
        return Call('pcCutoff/default', 'POST', { type, cutoff });
    },

    getAffid() {
        return Call('pcCutoff/affid');
    },

    saveAffid(cutoff) {
        return Call('pcCutoff/affid', 'POST', cutoff);
    },

    updateAffid(id, cutoff) {
        return Call(`pcCutoff/affid/${id}`, 'PUT', cutoff);
    },

    deleteAffid(id) {
        return Call(`pcCutoff/affid/${id}`, 'DELETE');
    },

    getHourFactor() {
        return Call('pcCutoff/hourFactor');
    },

    saveHourFactor(factors) {
        return Call('pcCutoff/hourFactor', 'POST', { factors });
    },

    getDummyHourFactor() {
        return Call('pcCutoff/dummyHourFactor');
    },

    saveDummyHourFactor(factors) {
        return Call('pcCutoff/dummyHourFactor', 'POST', { factors });
    },
};

export default PcCutoff;



// WEBPACK FOOTER //
// ./src/services/API/components/PcCutoff.js